import React, { Component } from 'react';
import Footer from '../../components/common/Footer';
import Topbar from '../../components/common/Topbar';
import SpotBooking from '../../components/transaction/Booking/SpotBooking';

class SpotBookingPage extends Component {
    render() {
        return (
            <>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">

                        <Topbar />

                        <div className="container-fluid">

                            <SpotBooking />

                        </div>

                    </div>

                    <Footer />

                </div>
            </>
        );
    }
}

export default SpotBookingPage;